import {getTableColumnWidth} from '../../../helpers/dataHelper';

export function changeFeaturesWidthOnColumnWidth(features, featuresSettings, allEventsAndAllFormulas, columnName, sign) {
    features.forEach((feature) => {
        const featureSettings = featuresSettings[feature.name];
        const columnIndex = allEventsAndAllFormulas.findIndex((column) => column.name === columnName);
        if (!feature.columnsWidth) {
            feature.columnsWidth = [];
        }
        const columnWidth = getTableColumnWidth(feature.columnsWidth[columnIndex]);
        if (featureSettings.width) {
            const newWidth = +featureSettings.width + (+columnWidth * sign);
            featureSettings.width = newWidth;
        }
    });
}

export function changeFeatureWidthOnColumnWidth(feature, featureSettings, allEventsAndAllFormulas, columnName, sign) {
    const columnIndex = allEventsAndAllFormulas.findIndex((column) => column.name === columnName);
    const columnWidth = getTableColumnWidth(feature.columnsWidth[columnIndex]);
    if (featureSettings.width) {
        const newWidth = +featureSettings.width + (+columnWidth * sign);
        featureSettings.width = newWidth;
    }
}